import styles from './Details.module.css';
import PageTitleBarComponent from '../PageTitleBar/PageTitleBar';
import CardComponent from '../Card/Card';

export default function DetailsComponent(props) {

    const getImgColsClassName = (cols) => {
        switch (cols) {
            case 2:
                return styles.imgCols2;
            case 3:
                return styles.imgCols3;
            case 6:
                return styles.imgCols6;
            default:
                return styles.imgCols6;
        }
    }

    return (
        <>
            <PageTitleBarComponent pageTitle={props.data?.card?.title} />
            <section className={styles.detailsContainer}>
                <CardComponent item={props.data?.card} />
                {/* 
                <div className={styles.paraDescription}>
                    <b>"Jackify"</b> is a cutting-edge music streaming application designed to deliver a seamless and personalized listening experience to users worldwide. With an extensive library of songs spanning various genres, curated playlists, and innovative features, "Jackify" redefines how users engage with music, offering a platform that caters to both casual listeners and passionate music aficionados alike.
                    <br /><br />

                    <b>Key Features:</b>
                    <ol>
                        <li>
                            <b>Vast Music Library:</b>
                            <ul>
                                <li>
                                    "Jackify" boasts an extensive catalog of songs from artists around the globe, covering diverse genres such as pop, rock, hip-hop, electronic, and more.
                                </li>
                                <li>
                                    Users can access millions of tracks, ensuring there's something for every mood and occasion.
                                </li>
                            </ul>
                        </li>

                        <li>
                            <b>Personalized Recommendations:</b>
                            <ul>
                                <li>Leveraging advanced algorithms and user preferences, "Jackify" provides personalized music recommendations tailored to each individual's taste.</li>
                                <li>The app analyzes listening habits, favorite genres, and liked songs to curate customized playlists and suggestions, enhancing the discovery of new music.</li>
                            </ul>
                        </li>

                        <li>
                            <b>Curated Playlists and Stations:</b>
                            <ul>
                                <li>"Jackify" offers a wide array of curated playlists and radio stations curated by music experts and algorithms.</li>
                                <li>Users can explore themed playlists for different activities, moods, or genres, providing a curated listening experience for every occasion.</li>
                            </ul>
                        </li>

                        <li>
                            <b>Offline Listening:</b>
                            <ul>
                                <li>"Jackify" allows users to download their favorite songs, albums, and playlists for offline listening.</li>
                                <li>This feature enables uninterrupted music playback, even in areas with limited or no internet connectivity, making it ideal for travel or commutes.</li>
                            </ul>
                        </li>

                        <li>
                            <b>Customizable Profiles:</b>
                            <ul>
                                <li>Users can create personalized profiles on "Jackify," where they can customize their listening preferences, profile picture, and bio.</li>
                                <li>The app also offers social features, allowing users to follow friends, share playlists, and discover new music based on their friends' activity.</li>
                            </ul>
                        </li>

                        <li>
                            <b>High-Quality Audio Streaming:</b>
                            <ul>
                                <li>"Jackify" ensures high-quality audio streaming, delivering crystal-clear sound with options for different bitrates and audio qualities to suit users' preferences and network conditions.</li>
                            </ul>
                        </li>
                    </ol>
                    <br />

                    <b>Benefits:</b>
                    <ul>
                        <li>
                            <b>Tailored Listening Experience:</b> Personalized recommendations and curated playlists enhance user engagement, ensuring that users discover new music aligned with their tastes.
                        </li>
                        <li>
                            <b>Versatile Music Library: </b>With millions of tracks available, users can explore a vast array of genres, artists, and albums, catering to diverse musical preferences.
                        </li>
                        <li>
                            <b>Convenience: </b>Offline listening and customizable profiles offer flexibility and convenience, allowing users to enjoy their favorite music anytime, anywhere.
                        </li>
                        <li>
                            <b>Social Integration: </b>Social features enable users to connect with friends, share music recommendations, and discover new tracks based on their social network activity.
                        </li>
                    </ul>

                    <b>"Jackify"</b> revolutionizes the way users experience music, providing a dynamic and immersive platform that celebrates the art of sound. Whether users are seeking personalized recommendations, curated playlists, or social interactions, "Jackify" delivers an unparalleled music streaming experience that resonates with users worldwide.
                </div > */}

                <div className={styles.imageCollage}>
                    {
                        props.data?.images?.map((item, index) => {
                            let animation =
                            " animate__animated animate__fadeInUp animate__slow ";

                        switch (index) {
                            case 0:
                                animation += "";
                                break;
                            case 1:
                                animation += "animate__delay-1s";
                                break;
                            case 2:
                                animation += "animate__delay-2s";
                                break;
                            case 3:
                                animation += "animate__delay-3s";
                                break;
                            case 4:
                                animation += "animate__delay-4s";
                                break;
                            default:
                                animation += "animate__delay-5s";
                                break;
                        }

                            return (<picture key={index} className={animation + ' ' + getImgColsClassName(+item.cols)} >
                                <source type="image/webp" media="(min-width:750px)" srcSet={item.image1x + ' 1x, ' + item.image2x + ' 2x'} alt={item.alt} />
                                <source type="image/webp" media="(min-width:300px)" srcSet={item.imageM1x + ' 1x, ' + item.imageM2x + ' 2x'} alt={item.alt} />
                                <img src={item.image1x} alt={item.alt} />
                            </picture>)
                        }
                        )
                    }
                </div>

            </section >
        </>
    )
}
